import L from 'leaflet';
import _ from 'lodash';
import { objectColors } from '@iso/constants/objectColors';
import { livestockIcons } from './AssetIcons/livestock_icons';

export const IconMob = (color, asset_total, type) => {
  var asset_color = '';
  _.forEach(objectColors, (color_obj) => {
      if(color_obj.value === color){
        asset_color = color_obj.color;
      }
  });

  var icon_url = '';

  switch(type){
    case 'cattle':
      icon_url = livestockIcons.cow(asset_color, asset_total);
      break;
    case 'sheep':
      icon_url = livestockIcons.sheep(asset_color, asset_total);
      break;
    case 'goat':
      icon_url = livestockIcons.goat(asset_color, asset_total);
      break;
    case 'other':
      icon_url = livestockIcons.otherAnimal(asset_color, asset_total);
      break;
    default:
      icon_url = 'data:image/svg+xml;charset=UTF-8,%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2242%22%20height%3D%2250%22%20viewBox%3D%220%200%2042%2050%22%3E%0A%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%3Cpath%20fill%3D%22%232c303e%22%20fill-opacity%3D%221%22%20d%3D%22M35.7812122%2C6.144%20L36.9372122%2C7.3%20C44.0342122%2C15.546%2043.6762122%2C27.995%2035.8642122%2C35.816%20L21.0001122%2C50.0004%20L6.14121223%2C35.816%20C-1.67278777%2C27.995%20-2.02978777%2C15.544%205.06921223%2C7.298%20L6.22421223%2C6.144%20C10.2652122%2C2.097%2015.5512122%2C0.049%2020.8512122%2C0.001%20L21.1292122%2C0%20C26.4292122%2C0.043%2031.7172122%2C2.085%2035.7632122%2C6.126%20L35.7812122%2C6.144%20Z%22%2F%3E%0A%20%20%3Ccircle%20cx%3D%2221%22%20cy%3D%2221%22%20r%3D%2218%22%20fill%3D%22%23FFF%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A';
  }

  var icon = new L.Icon({
    iconUrl: icon_url,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: [94, 104],
    iconAnchor: [34, 75],
    className: 'custom-icon-marker mob'
  });

  return icon;
};